'use client';
import { RequireRole } from '../../components/console-shell';
import { PolicyReading } from '../../components/desk/policy-reading';
import { POLICY_READ_ROLES } from '../../lib/policy-api';
import { useSession } from '../../lib/session';
export default function PoliciesPage() {
  const { hasRole } = useSession();
  return <RequireRole roleCode={POLICY_READ_ROLES.find(hasRole) ?? 'ORGANIZATION_ADMIN'}><PolicyReading /></RequireRole>;
}
